import { observer } from 'mobx-react';

import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';

import { MainSettingsMfeStore } from '../../stores/main-settings-mfe.store';

export const MainSettingsPage = provide({
    singletons: [MainSettingsMfeStore],
})(
    observer(() => {
        const [{ data, basename, source }] = useDependencies(MainSettingsMfeStore);

        return (
            <Loader
                data={data}
                src={source}
                className="w-100"
                loadingFallback={<CenteredSpinner />}
                basename={basename}
            />
        );
    }),
);
